package com.milta.core.localization.translations.es

import com.milta.core.localization.CommonStrings

internal val Common = CommonStrings(
    appName = "Milta",
    ok = "OK",
    cancel = "Cancelar",
    confirm = "Confirmar",
    save = "Guardar",
    delete = "Eliminar",
    back = "Volver",
    loading = "Cargando…",
    retry = "Reintentar",
    language = "Idioma",
    welcomeTitle = "Bienvenido a Milta",
    welcomeSubtitle = "Tu asistente inteligente de entregas",
    alreadyHaveAccount = "Ya tengo una cuenta",
    createAccount = "Crear una cuenta",
    continueWithGoogle = "Continuar con Google",
    continueWithApple = "Continuar con Apple",
    oauthErrorGeneric = "Se produjo un error al iniciar sesión. Inténtalo de nuevo.",
    oauthAppleWebComingSoon = "El inicio de sesión con Apple estará disponible pronto en la web.",
    oauthDriverAccountNotAllowedOnWeb = "Las cuentas de conductor no pueden acceder al panel web. Inicia sesión desde la aplicación móvil.",
    oauthAccountNotFoundOnWeb = "No se encontró ninguna cuenta de Milta para esta cuenta de Google.",
    errorOffline = "Sin conexión a internet.",
    navTourneesDuJour = "Rutas de hoy",
    navAjouterUneTournee = "Añadir una ruta",
    navHistoriqueDesPreuves = "Historial de entregas",
    navParametres = "Ajustes",
    sidebarRoleManagerLabel = "Gerente",
    noDeliveriesYetTitle = "Sin entregas todavía",
    noDeliveriesYetSubtitle = "Toca «Añadir entregas» para agregar algunas",
    optimizationUnavailableExplanation = "¿Quieres crear la ruta sin optimizar, o reintentarlo?",
    createWithoutOptimizationAction = "Crear sin optimizar",
    gpsAppSheetTitle = "Elegir una aplicación de navegación",
    addressSearchingLabel = "Buscando…",
)
